module.exports = __webpack_public_path__ + "static/img/code-code.c70dd996.png";